"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.common.yes': 'Sì',
    'profession.common.no': 'No',
};
